/** Unique id for client-side keys and locally created items. */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "generateRandomId", {
    enumerable: true,
    get: function() {
        return generateRandomId;
    }
});
const generateRandomId = ()=>crypto.randomUUID();
